/**
 * 声网 用户端 拉流模块
 */

import { debug, request, track, user, utils, config } from 'lib';

const log = debug.create('agoraUser');
const error = debug.create('agoraUser:error');

class AgoraUserWeb {
  client: any;
  roomId: string;
  userId: number;
  container: HTMLVideoElement;
  //
  mute = false;

  constructor(userId, roomId, container) {
    this.roomId = roomId;
    this.userId = parseInt(userId, 10);
    this.container = container;
    this.initClient();
  }

  trackLog(event_type: string, content?: any, ...rest) {
    track.send({
      event: 'RtcAgoraWebUser',
      event_type,
      content,
    });
    log(event_type, content, ...rest);
  }

  async initClient() {
    this.client = window.AgoraRTC.createClient({
      mode: 'live',
      codec: 'h264',
    });
    this.client.setClientRole('audience', { level: 1 });

    const token = await this.getToken();
    await this.client.join(config.agoraAppId, this.roomId, token, this.userId);

    this.trackLog('initClient');

    this.client.on('user-published', async (user, mediaType) => {
      this.trackLog('user-published', user.uid);

      await this.client.subscribe(user, mediaType);
      if (mediaType === 'video') {
        user.videoTrack.play(this.container);
      }
      if (mediaType === 'audio') {
        user.audioTrack.play();
        if (this.mute === false) {
          user.audioTrack.setVolume(0);
        }
      }
    });
    this.client.on('connection-state-change', (curState, revState, reason) => {
      this.trackLog('connection-state-change', {
        roomId: this.roomId,
        userId: this.userId,
        curState,
      });
    });
    this.client.on('user-unpublished', async (user, mediaType) => {
      this.trackLog('user-unpublished', user.uid);

      await this.client.unsubscribe(user, mediaType);
    });
  }

  async getToken() {
    const res: any = await request.cryolite.post('/api/v1/liveRoom/enter', {
      room_ids: [this.roomId],
    });

    return res.data.token_map[this.roomId].room_token;
  }

  mutePlayStreamAudio(streamId: string, mute: boolean) {
    this.trackLog('mutePlayStreamAudio', { streamId, mute });
    this.mute = mute;
    this.client.remoteUsers[0]?.audioTrack?.setVolume(!mute ? 0 : 100);
  }

  async leave() {
    await this.client.leave();
    this.trackLog('leave', '离开声网成功');
  }
}

export default AgoraUserWeb;
